import React, { useContext, useState } from 'react';
import { Button, Grid, Typography, TextField, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { IMaintenance, toolContext } from '../ToolDetailsContext';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import Moment from 'react-moment';
import { DeleteIconButton, EditIconButton } from 'components';


let ToolMaintenances = () => {
    let service = useContext(toolContext);


    const defaultToolMaintenance: IMaintenance = {
        notes: '',
        maintenanceDate: null,
        nextMaintenanceDate: null
    };


    let [toolMaintenance, setToolMaintenance] = useState<IMaintenance>(defaultToolMaintenance);
    let [editToolMaintenanceIx, setEditToolMaintenanceIx] = useState<number | null>(null);
    let [editToolMaintenance, setEditToolMaintenance] = useState<IMaintenance>({} as IMaintenance);
    let [showAddMaintenanceForm, setShowAddMaintenanceForm] = useState<boolean>(false);



    let handleEditToolMaintenance = (index: number) => {
        setEditToolMaintenance(service.toolMaintenances[index]);
        setEditToolMaintenanceIx(index);
    }

    let handleChangeToolMaintenances = (toolMaintenanceFormData: IMaintenance, action: 'add' | 'edit' | 'delete') => {
        service.handleChangeToolMaintenances(toolMaintenanceFormData, action);
        setToolMaintenance(defaultToolMaintenance);
        setEditToolMaintenance(defaultToolMaintenance);
        setEditToolMaintenanceIx(null);
        if (action === 'add') {
            setShowAddMaintenanceForm(false);
        }
    }

    let closeAddMaintenanceForm = () => {
        setToolMaintenance(defaultToolMaintenance);
        setShowAddMaintenanceForm(false);
    }

    let handleDeleteMaintenance = (maintenance: IMaintenance) => {
        if (window.confirm("Vuoi eliminare questa Manutenzione?")) {
            handleChangeToolMaintenances(maintenance, 'delete');
        }
    }


    return (
        <Grid item xs={12}>
            <Typography variant="h5">Manutenzioni</Typography>

            {showAddMaintenanceForm === true &&
                <Grid container>
                    <Grid item xs={12} md={9}>
                        <Grid container>
                            <Grid item xs={6}>
                                <DesktopDatePicker
                                    label="Data"
                                    value={toolMaintenance.maintenanceDate}
                                    onChange={(value) => setToolMaintenance({ ...toolMaintenance, maintenanceDate: value != null ? moment(value) : null })}
                                    renderInput={(props) => <TextField {...props} size='small' />}
                                    inputFormat="DD/MM/YYYY"
                                    
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DesktopDatePicker
                                    label="Prossima manutenzione"
                                    value={toolMaintenance.nextMaintenanceDate}
                                    onChange={(value) => setToolMaintenance({ ...toolMaintenance, nextMaintenanceDate: value != null ? moment(value) : null })}
                                    renderInput={(props) => <TextField {...props} size='small' />}
                                    inputFormat="DD/MM/YYYY"
                                    
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Note"
                                    value={toolMaintenance.notes}
                                    onChange={(event) => setToolMaintenance({ ...toolMaintenance, notes: '' + event.target.value })}
                                    size="small"
                                    margin="none"
                                    multiline={true}
                                    rows={4}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs />
                    <Grid item>
                        <Button
                            variant="contained"
                            onClick={() => handleChangeToolMaintenances(toolMaintenance, 'add')}
                        >
                            Aggiungi
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => closeAddMaintenanceForm()}
                        >
                            Annulla
                        </Button>
                    </Grid>
                </Grid>
            }

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Data Prossima Manutenzione</TableCell>
                        <TableCell>Note</TableCell>
                        <TableCell align="right">
                            {showAddMaintenanceForm === false && editToolMaintenanceIx === null &&
                                <Button
                                    variant="outlined"
                                    size="small"
                                    style={{ margin: 0 }}
                                    onClick={() => setShowAddMaintenanceForm(true)}
                                >
                                    Aggiungi
                                </Button>
                            }
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.toolMaintenances.length <= 0 &&
                        <TableRow>
                            <TableCell colSpan={12}>
                                <Typography variant="subtitle2">Nessuna Manutenzione</Typography>
                            </TableCell>
                        </TableRow>
                    }
                    {service.toolMaintenances.map((maintenance, index) =>
                        <React.Fragment key={index}>
                            {/* NESSUNA SELEZIONE PER L'EDIT */}
                            {(editToolMaintenanceIx == null || editToolMaintenanceIx !== index) &&
                                <TableRow hover>
                                    <TableCell>
                                        {maintenance.maintenanceDate != null &&
                                            <Moment date={maintenance.maintenanceDate} format="LL" />
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {maintenance.nextMaintenanceDate &&
                                            <Moment date={maintenance.nextMaintenanceDate} format="LL" />
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {maintenance.notes}
                                    </TableCell>
                                    <TableCell align="right">
                                        {showAddMaintenanceForm === false &&
                                            <>
                                                <EditIconButton onClick={() => handleEditToolMaintenance(index)} />
                                                <DeleteIconButton onClick={() => handleDeleteMaintenance(maintenance)} />
                                            </>
                                        }
                                    </TableCell>
                                </TableRow>
                            }

                            {/* SELEZIONATA PER L'EDIT */}
                            {editToolMaintenanceIx === index &&
                                <>
                                    <TableRow>
                                        <TableCell style={{ borderBottom: 'none' }}>
                                            {maintenance.maintenanceDate != null &&
                                                <Moment date={maintenance.maintenanceDate} format="LL" />
                                            }
                                        </TableCell>
                                        <TableCell colSpan={2} style={{ borderBottom: 'none' }}>
                                            <DesktopDatePicker
                                                label="Prossima manutenzione"
                                                value={editToolMaintenance.nextMaintenanceDate}
                                                onChange={(value) => setEditToolMaintenance({ ...editToolMaintenance, nextMaintenanceDate: value != null ? moment(value) : null })}
                                                renderInput={(props) => <TextField {...props} size='small' />}
                                                inputFormat="DD/MM/YYYY"
                                                
                                            />
                                        </TableCell>
                                        <TableCell align="right" style={{ borderBottom: 'none' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => handleChangeToolMaintenances(editToolMaintenance, 'edit')}
                                            >
                                                Salva
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                onClick={() => setEditToolMaintenanceIx(null)}
                                            >
                                                Annulla
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow hover>
                                        <TableCell colSpan={3}>
                                            <TextField
                                                label="Note"
                                                value={editToolMaintenance.notes}
                                                onChange={(event) => setEditToolMaintenance({ ...editToolMaintenance, notes: '' + event.target.value })}
                                                size="small"
                                                margin="none"
                                                multiline={true}
                                                rows={4}
                                            />
                                        </TableCell>
                                        <TableCell />
                                    </TableRow>
                                </>
                            }
                        </React.Fragment>
                    )}
                </TableBody>
            </Table>
        </Grid>
    )
}

export default ToolMaintenances;